import type { FaireProductEntity } from "../../entity_types/product";

export const p_dkchqu54rp: FaireProductEntity = {
  token: "p_dkchqu54rp",
  type: "product",
  name: "Orgonite Pyramid",
  brandToken: "b_6k5xkw1g4n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/08c04bb68ca9208222fd6de12cd1f7bb2e085826f374f69e04fea4abca573e64.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.55,
  description:
    "Crystal Point Orgonite Pyramid\n3.25 inches tall\nOrgonite Pyramids is a device which consists of epoxy resin, metals of different density, crystal and minerals.  Orgonite has a powerful energy and protects against negative events that have physical and energetic nature.\nWas $12.00, now $4.00!",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:27.678Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
